import React, { useState } from 'react';
import '../styles/PaymentModal.css';

const PaymentModal = ({ 
  isOpen, 
  title, 
  userName, 
  paymentDays, 
  setPaymentDays, 
  paymentAmount, 
  setPaymentAmount, 
  paymentMethod, 
  setPaymentMethod, 
  onConfirm, 
  onCancel 
}) => {
  if (!isOpen) return null;

  // Función para incrementar días de 30 en 30
  const incrementDays = () => {
    setPaymentDays(prevDays => prevDays + 30);
  };

  // Función para decrementar días de 30 en 30 (mínimo 30)
  const decrementDays = () => {
    setPaymentDays(prevDays => (prevDays > 30 ? prevDays - 30 : 30));
  };

  // Opciones de métodos de pago
  const paymentMethods = [
    { value: 'tcredito', label: 'Tarjeta de Crédito' },
    { value: 'tdebito', label: 'Tarjeta de Débito' },
    { value: 'transferencia', label: 'Transferencia' },
    { value: 'efectivo', label: 'Efectivo' },
    { value: 'paypal', label: 'PayPal' },
    { value: 'oxxo', label: 'OXXO' }
  ];

  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal-container">
        <div className="payment-modal-header">
          <h2>{title}</h2>
        </div>
        <div className="payment-modal-body">
          <p>Registrar pago y renovar suscripción para: <strong>{userName}</strong></p>
          
          <div className="payment-form">
            <div className="form-group">
              <label>Días de suscripción:</label>
              <div className="days-input-group">
                <button 
                  type="button" 
                  className="days-btn" 
                  onClick={decrementDays}
                  disabled={paymentDays <= 30}
                >
                  -
                </button>
                <div className="days-display">{paymentDays} días</div>
                <button 
                  type="button" 
                  className="days-btn" 
                  onClick={incrementDays}
                >
                  +
                </button>
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="paymentAmount">Monto del pago ($):</label>
              <input 
                type="number" 
                id="paymentAmount" 
                value={paymentAmount} 
                onChange={(e) => setPaymentAmount(e.target.value)}
                min="0.00" 
                step="0.01" 
                className="payment-input"
                placeholder="Ingrese el monto"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="paymentMethod">Método de pago:</label>
              <select 
                id="paymentMethod" 
                value={paymentMethod} 
                onChange={(e) => setPaymentMethod(e.target.value)}
                className="payment-select"
              >
                {paymentMethods.map(method => (
                  <option key={method.value} value={method.value}>{method.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="payment-modal-footer">
          <button className="btn-cancel" onClick={onCancel}>
            Cancelar
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            Confirmar Pago
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
